import { EndpointRequest } from "../../_system/EndpointRequest";
import {
  ReadLocationsRequestDto as RequestDto,
  ReadLocationsResponseDto as ResponseDto,
} from "../../api/locations/list/dtos";
import { Location } from "../../models";
import { PagingMeta } from "../../models/_system";
import { Api } from "../../api";

interface Data {
  data: Location[];
  meta: PagingMeta;
}
export const list = new EndpointRequest<RequestDto, ResponseDto, Data>(
  "LIST_LOCATIONS",
  Api.locations.list,
  ({ data: { data, meta } }): Data => {
    return {
      data: data.map((i) => new Location(i)),
      meta: new PagingMeta(meta),
    };
  }
);
